import { Component, OnInit , Inject} from '@angular/core';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { PopupOutstandingBalanceComponent } from '../../../referred/components/popup-outstanding-balance/popup-outstanding-balance.component';
@Component({
  selector: 'app-popup-refer-paperless',
  templateUrl: './popup-refer-paperless.component.html',
  styleUrls: ['./popup-refer-paperless.component.sass']
})
export class PopupReferPaperlessComponent implements OnInit {
  public pasatiempoSelect = null;
  public currentSuscriber;
  public emailClient;
  public origin;
  public dateProfile = "";
  public paperless = false;
  public pasatiempos;
  public selectBan;
  public pasatiempoList;
  public paperlessDisable = true;
  public account_info = [];
  public info = [];
  public token: string = sessionStorage.getItem("token");
  public birthdate;
  public productType;
  public currentBalance;
  public expiredBalance;
  public delinquent;
  public cr = '';
  constructor(public matDialogRef: MatDialogRef<PopupReferPaperlessComponent>,@Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private loadingScreenService: LoadingScreenService, private global: GlobalService, private services: Service,public dialog: MatDialog,public datePipe: DatePipe) {
      this.productType=data.productType;
      this.currentSuscriber=data.suscriptor;
      this.origin = data.origin;
      if (data.delinquent != undefined) {
        this.delinquent = data.delinquent;
      }
  }

  ngOnInit() {
    this.loadHobbies();
    this.pasatiempos = [];
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.account_info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo;
    this.birthdate = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.dOBField;
    this.birthdate = this.conversionReverseGreenwich(this.birthdate);
    this.expiredBalance = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
    this.emailClient = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.emailField;
    this.paperless = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.RefererResponse.paperless;
  }
  dataLoading(sw) {
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.account_info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo;
    this.paperless = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.paperlessField;
    this.expiredBalance = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
    // let info=JSON.parse(atob(sessionStorage.getItem("getAccountDetails")));

  }
  loadHobbies() {
    this.services.getHobbies(this.token, this.currentSuscriber).subscribe(resp => {
      if (resp.hasError == false) {
        for (let i = 0; i < resp.hobbiesList.length; i++) {
          this.pasatiempos.push(resp.hobbiesList[i].hobbie);
        }
      }
    });
  }
  setPaperless(toStatus) {
    this.paperless = toStatus;
  }
  public close() {
    this.matDialogRef.close('cancel');
  }
  updateAccount() {
    let paperlessTxt = 'N';
    if (this.paperless==true) {
        paperlessTxt = 'Y';
        if (this.pasatiempoSelect !== null) {
          this.loadingScreenService.startLoading();
          this.services.updatePaperless(this.selectBan,this.token).subscribe(data2 => {
            if (data2.HasError == false) {
              this.birthdate = this.conversionDateTime(this.birthdate);
              this.services.addMenber(1, sessionStorage.getItem("name"),this.currentSuscriber, this.selectBan, this.account_info["accountTypeField"],
                this.account_info["accountSubtypeField"], this.productType, 'web',this.birthdate, this.pasatiempoSelect, this.emailClient,paperlessTxt, this.token).subscribe(data => {
                  if (data.hasError == false) {
                    sessionStorage.setItem("memberID",data.memberID);
                    this.services.getValidateReferrer(this.token, this.currentSuscriber, this.selectBan).subscribe(data => {
                      if (data.hasError == false) {
                        this.currentBalance = data.Balance;
                        if (this.currentBalance > 0 && this.delinquent!='N') {
                          if (this.expiredBalance.search('CR') > -1) {
                            this.cr = 'CR';
                            this.expiredBalance = parseFloat(this.expiredBalance);
                          }
                          else {
                            this.cr = '';
                          }
                          this.loadingScreenService.stopLoading();
                          const dialogConfig = new MatDialogConfig();
                          dialogConfig.disableClose = true;
                          dialogConfig.autoFocus = true;
                          dialogConfig.data = { expiredBalance: this.expiredBalance, currentBalance: this.currentBalance, cr: this.cr, origin:this.origin };
                          const dialogRef = this.dialog.open(PopupOutstandingBalanceComponent, dialogConfig);
                          dialogRef.afterClosed().subscribe(value => {
                            if (value != "cancel") {}
                          });
                        }
                        else {
                          this.close();
                          this.loadingScreenService.stopLoading();
                          this.global.notif("Se han actualizado tus datos correctamente.");
                          if(this.origin=='referred'){
                            this.router.navigate(['internalreferred']);
                          }
                          else{
                            this.router.navigate(['redeem']);
                          }
                        }
                      }
                      else {
                        this.loadingScreenService.stopLoading();
                        this.global.notif(data.errorDisplay);
                      }
                    });
                  }
                  else {
                    this.loadingScreenService.stopLoading();
                    this.global.notif(data.errorDisplay);
                  }
                });
            }
            else{
              this.loadingScreenService.stopLoading();
              this.global.notif(data2.ErrorDesc);
            }
          });
        }
        else {
          this.loadingScreenService.stopLoading();
          this.global.notif("Lo sentimos pero debe seleccionar un pasatiempo");
        }
    }
    else {
      this.loadingScreenService.stopLoading();
      this.global.notif("Lo sentimos pero esta opcion solo esta disponibles con Paperless activo");
    }
  }
  conversionDateTime(date) {
    let dateTime = this.datePipe.transform(date, 'MM/dd/yyyy');
    return dateTime;
  }
  conversionReverseGreenwich(date) {
    let dt = new Date(date);
    return dt;
  }
}
